export const shouldEnableRealtime = (): boolean => {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  // Avoid opening WebSockets in Lighthouse/SEO audits or bots
  if (/\bLighthouse\b|\bChrome-Lighthouse\b|\bbot\b|\bCrawler\b/i.test(ua)) return false;
  if (document.visibilityState && document.visibilityState !== 'visible') return false;
  if ('onLine' in navigator && navigator.onLine === false) return false;
  return true;
};
